// Error and not-found boundaries for routes.
import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import ErrorPage from "src/components/app/ErrorPage/ErrorPage";

const useRetry = (reset: () => void) => {
  const router = useRouter();
  return () => {
    reset();
    void router.invalidate();
  };
};

/** Full-page error (root and public layouts). */
export const RouteErrorPage = ({ error, reset }: ErrorComponentProps) => (
  <ErrorPage error={error as Error} retry={useRetry(reset)} />
);

/** Keeps the sidebar and top bar around a failed page, so people can navigate away from it. */
export const InlineRouteErrorPage = ({ error, reset }: ErrorComponentProps) => (
  <ErrorPage error={error as Error} retry={useRetry(reset)} variant="inline" />
);

export const NotFoundPage = () => <ErrorPage type="not-found" />;
